import ProductList from '@/components/Product/ProductList'
import ParentProductList from '@/components/Product/ParentProductList'
import ProductForm from '@/components/Product/ProductForm'
import ProductDetail from '@/components/Product/ProductDetail'

let ProductRouter = [{
  path: '/product/parents',
  name: 'ParentProductList',
  component: ParentProductList,
  meta: {
    title: 'Produits spéciaux',
    requiresAuth: true,
    authorizations: ['product_index', 'desktop_access']
  }
},{
  path: '/product',
  name: 'ProductList',
  component: ProductList,
  meta: {
    title: 'Produits',
    requiresAuth: true,
    authorizations: ['product_index', 'desktop_access']
  }
}, {
  path: '/product/:id/edit',
  name: 'ProductEdit',
  component: ProductForm,
  meta: {
    title: 'Modifier un produit',
    requiresAuth: true,
    authorizations: ['product_edit', 'desktop_access']
  }
}, {
  path: '/product/:id',
  name: 'ProductDetail',
  component: ProductDetail,
  meta: {
    title: 'Fiche produit',
    requiresAuth: true,
    authorizations: ['product_show', 'desktop_access']
  }
}]

export default ProductRouter



// WEBPACK FOOTER //
// ./src/components/Product/router.js